export * from "./allBlocks.pure";

import { RegisterAllNodeParticleBlocks } from "./allBlocks.pure";
RegisterAllNodeParticleBlocks();
